module.exports = __webpack_public_path__ + "static/media/help06.f21bf29f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/help/help06.png
// module id = 430
// module chunks = 0